/**
 * T-29 — Darstellung der Mail-App: „Unterhaltungen" fasst die Nachrichten
 * einer `conversationId` zu EINER Zeile zusammen (Stand vor T-29, weiterhin
 * Standard); „einzeln" zeigt jede Mail als eigene Zeile und im Lesebereich nur
 * die angeklickte Nachricht statt des ganzen Verlaufs.
 *
 * Die Wahl ist eine Frage der Darstellung, nicht der Daten: Zuordnen zu einem
 * Vorgang nimmt in beiden Ansichten den ganzen Schriftwechsel mit (#1599).
 */
export type MailAnsicht = "unterhaltungen" | "einzeln";

/** Scope in der `UserPreference`-Ablage (pro Person, serverseitig gespeichert). */
export const MAIL_ANSICHT_SCOPE = "mail.ansicht";

/** Schneller Startwert im Browser, bis der Serverwert eingetroffen ist. */
export const MAIL_ANSICHT_LOCAL_KEY = "kmvs.mailAnsicht";

export const MAIL_ANSICHT_STANDARD: MailAnsicht = "unterhaltungen";

/** Alles außer dem bekannten Wert „einzeln" fällt auf den Standard zurück. */
export function normalisiereMailAnsicht(value: unknown): MailAnsicht {
    return value === "einzeln" ? "einzeln" : MAIL_ANSICHT_STANDARD;
}
